import React from 'react';

function NotFound() {
  return <div>Error 404: NotFound</div>;
}

export default NotFound;
